import { shallowEqual, useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { selectIsGuest } from 'redux/db/reducers';
import * as S from './styles';

interface TabBarProps {
	labels: string[];
	activeLabel: string;
	onChange: (label: string) => void;
}

const TabBar = ({ labels, activeLabel, onChange }: TabBarProps) => {
	const { sidebarDocked, isGuest } = useSelector((r: RootReducer) => {
		return {
			sidebarDocked: r.mode.sidebarDocked,
			isGuest: selectIsGuest(r.db),
		};
	}, shallowEqual);

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<S.Base makeSpaceForSidebar={!isGuest && !sidebarDocked}>
			<S.Divider />
			<S.Tabs>
				{labels.map((label) => (
					<S.Tab key={label} active={label === activeLabel} onClick={() => onChange(label)}>
						{label}
					</S.Tab>
				))}
			</S.Tabs>
		</S.Base>
	);
};

export default TabBar;
